<template>
  <div id="app">
	<router-view />
  </div>
</template>

<script>
	export default {
	  name: 'app',
	  
	  created() {
	      // 在页面加载时读取sessionStorage里的状态信息
	      if (sessionStorage.getItem('store')) {
	        this.$store.replaceState(
	          Object.assign(
	            {},
	            this.$store.state,
	            JSON.parse(sessionStorage.getItem('store'))
	          )
	        )
	      }
		  window.addEventListener('beforeunload', () => {
		    sessionStorage.setItem('store', JSON.stringify(this.$store.state))
		  })
	  }
	  
	}
	
	
	window.onload = function() {
	    document.addEventListener('touchstart', function(e) {
	      if (e.touches.length > 1) {
	        e.preventDefault()
	      }
	    })
	    document.addEventListener('gesturestart', function(e) {
	      e.preventDefault()
	    })
	  }
</script>

<style>
	@import url("../public/public.css");
</style>
